<template>
  <div>
    <div class="ccui-navigation" ref="noPrintTop">
      <el-button
        size="mini"
        type="primary-icon-medium"
        icon="icon-ccui-return"
        @click="handleBack"
      >
        返回
      </el-button>
      <div class="ccui-navigation-divider" />
      <!-- 面包屑 -->
      <el-breadcrumb
        class="ccui-navigation-crumbs-container"
        separator-class="el-icon-arrow-right"
      >
        <el-breadcrumb-item
          :to="{ path: $store.getters.getBreadcrumb('level1').path }"
          >{{ $store.getters.getBreadcrumb("level1").name }}</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/demouser/item-list' }"
          >代码生成</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/demouser/item-list' }"
          >用户</el-breadcrumb-item
        >

        <el-breadcrumb-item>
          <span>查看</span>
          <span class="ccui-curr-crumb ccui-ml-10">XXXX</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="ccui-app-container-detail2" style="padding-bottom:20px">
      <div class="ccui-app-container-detail-body">
        <el-group-title title="基本信息">
          <template slot="groupTitle">
            <el-form
              :model="formData"
              label-width="160px"
              class="ccui-form ccui-form-detail"
            >
              <el-form-item label="用户名：">
                {{ formData.userName }}
              </el-form-item>
              <el-form-item label="性别：">
                {{ formData.sex | sex }}
              </el-form-item>
              <el-form-item label="出生日期：">
                {{ formData.birthday | birthday }}
              </el-form-item>
              <el-form-item label="政治面貌：">
                {{ formData.politicalOutlook | politicalOutlook }}
              </el-form-item>
              <el-form-item label="工龄：">
                {{ formData.workYears }}
              </el-form-item>
              <el-form-item label="是否已婚：">
                {{ formData.isMarried | isMarried }}
              </el-form-item>
              <el-form-item label="年收入：">
                {{ formData.annualIncome }}
              </el-form-item>
              <el-form-item label="身份证号：">
                {{ formData.idNum }}
              </el-form-item>
              <el-form-item label="手机号：">
                {{ formData.userMobile }}
              </el-form-item>
              <el-form-item label="爱好：">
                {{ formData.hobby }}
              </el-form-item>
              <el-form-item label="备注：">
                {{ formData.remarks }}
              </el-form-item>
            </el-form>
          </template>
        </el-group-title>
      </div>
    </div>
  </div>
</template>

<script>
import { postGetDetail } from "../api/item-list";
// import { ishasAgentId } from "@/basa/utils";
export default {
  name: "demouser-item-detail",
  data() {
    return {
      formData: {}
    };
  },
  created() {
    const id = this.$route.params.id;
    this.getListDetail(id);
  },
  filters: {
    sex(value) {
      const sex = {
        0: "男",
        1: "女",
        2: "保密"
      };
      return sex[value];
    },
    birthday(value) {
      return value ? value.substr(0, 10) : "";
    },
    politicalOutlook(value) {
      const politicalOutlook = {
        0: "群众",
        1: "团员",
        2: "党员"
      };
      return politicalOutlook[value];
    },
    isMarried(value) {
      const isMarried = {
        0: "未婚",
        1: "已婚"
      };
      return isMarried[value];
    }
  },
  methods: {
    // 详情请求
    getListDetail(id) {
      const arr = [];
      arr.push(id);
      const obj = {
        ids: arr,
        isShowPageLoading: true
      };
      postGetDetail(obj)
        .then(res => {
          if (res.data.code == "0") {
            //this.form = res.data.data;
            this.formData = res.data.data;
            console.log(res);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    // 返回
    handleBack() {
      this.$router.push("/example-auto/demouser/item-list-all");
    }
  }
};
</script>
